const UPDATE_CHECK_INTERVAL = 30 * 60 * 1000

export default async function checkForUpdate (context) {
  if (!('serviceWorker' in navigator)) {
    return
  }

  // A controllerchange after the page already had a controller means a NEW
  // service worker activated (skipWaiting) — the running page is still
  // executing the OLD bundle until it reloads. Surface a reload prompt;
  // silently-stale clients spent 2026-07-09 posting old-shape payloads.
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      context.store.commit('system/SET_APP_UPDATE_AVAILABLE', true)
    })
  }

  const update = async () => {
    const registration = await navigator.serviceWorker.getRegistration()
    if (registration) {
      await registration.update()
    }
  }

  await update()
  window.addEventListener('online', update)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      update()
    }
  })
  setInterval(update, UPDATE_CHECK_INTERVAL)
}
